// Action types
const TOGGLE_DELETE_MODAL = 'TOGGLE_DELETE_MODAL';

const DEFAULT_STATE = {
  eventId: null,
  show: false
};

// Reducer
export default function (state = DEFAULT_STATE, { payload, type }) {
  switch (type) {
    case TOGGLE_DELETE_MODAL:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
}

// Action creators
export const toggleDeleteModal = (eventId) => ({
  type: TOGGLE_DELETE_MODAL,
  payload: {
    eventId,
    show: !!eventId
  }
});
